import React from 'react';
import { Box, Typography } from '@mui/material';
import PageHero from '../ui/pageHero/PageHero';

const ImprintPage = () => (
    <>
        <PageHero eyebrow="Legal" title="Imprint" />

        <Box component="section" sx={{ backgroundColor: 'background.default', py: { xs: 8, md: 12 }, px: '6%' }}>
            <Box sx={{ maxWidth: 700, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Typography variant="body1">
                    Nexora is a fictional company created as a portfolio and design
                    concept project. It is not a registered business, and no real
                    products, services, or client engagements exist behind it.
                </Typography>
                <Box>
                    <Typography variant="overline" sx={{ color: 'primary.main', display: 'block', mb: 1 }}>
                        Concept &amp; design
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        This site was designed and built as a demonstration piece.
                        Contact details shown elsewhere on the site are illustrative
                        and not monitored.
                    </Typography>
                </Box>
            </Box>
        </Box>
    </>
);

export default ImprintPage;
